import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { type PropsWithChildren, type ReactElement } from 'react';

import { queryClient as defaultClient } from '@app/config';

export interface QueryProviderProps extends PropsWithChildren {
  readonly client?: QueryClient;
}

export function QueryProvider({ children, client }: Readonly<QueryProviderProps>): ReactElement {
  return <QueryClientProvider client={client ?? defaultClient}>{children}</QueryClientProvider>;
}
